import { atom, useAtom, useAtomValue, useSetAtom } from "jotai";

export const isEnlargeSwatchAtom = atom<boolean>(false);

const useSetIsEnlargeSwatchAtomAtom = () => useSetAtom(isEnlargeSwatchAtom);
const useIsEnlargeSwatchAtomValue = () => useAtomValue(isEnlargeSwatchAtom);
const useIsEnlargeSwatchAtom = () => useAtom(isEnlargeSwatchAtom);

export const enlargeDrawerHeightAtom = atom<number>(660);

const useSetEnlargeDrawerHeightAtom = () => useSetAtom(enlargeDrawerHeightAtom);
const useEnlargeDrawerHeightAtomValue = () =>
  useAtomValue(enlargeDrawerHeightAtom);
const useEnlargeDrawerHeightAtom = () => useAtom(enlargeDrawerHeightAtom);

export {
  useIsEnlargeSwatchAtom,
  useIsEnlargeSwatchAtomValue,
  useSetIsEnlargeSwatchAtomAtom,
  useSetEnlargeDrawerHeightAtom,
  useEnlargeDrawerHeightAtomValue,
  useEnlargeDrawerHeightAtom
};
